import {observable, set, action, autorun, runInAction} from 'mobx';
import {BaseMobxState} from "./base-mobx-state";
import {BaseConfig} from "../config/base-config";
import {BaseDomainModel} from "../models/base-domain-model";
import {contractsUtils} from "../utils/contracts-utils";

export class BaseMobxStore {
  config: BaseConfig;
  stateContainer: BaseMobxState = observable({state: {}});
  vmTypeName: String = null;

  static injectables = [];

  constructor(config: BaseConfig = new BaseConfig(), state: BaseMobxState = new BaseMobxState()) {
    this.config = config;

    if (state) {
      this.vmTypeName = state.constructor.name;
    }

    this.setState(state);

    this.ensureRequiredTypes();
    this.initialize();
    this.registerFunctionsAsTransactions();
  }

  ensureRequiredTypes() {
    contractsUtils.requiredType(this.config, BaseConfig);
    contractsUtils.requiredType(this.stateContainer.state, BaseMobxState);

  }

  get state(): BaseMobxState {
    return this.stateContainer.state;
  }

  reset() {
    // const domain = this.state.domainModel;
    //
    // this.setState(state);
    // this.setDomainModel(domain);
  }

  initialize() {
  }

  registerFunctionsAsTransactions() {
    const currentProps = Object.getOwnPropertyNames((this));
    const childProps = Object.getOwnPropertyNames(Object.getPrototypeOf(this));
    const allProps = [...currentProps, ...childProps];
    const allFunctions = allProps.filter(x => typeof this[x] === 'function').filter(x => x !== 'constructor');

    allFunctions.forEach(f => this[f] = action(this[f].bind(this)));
  }

  setState(state: BaseMobxState) {
    const object = {
      state
    }

    set(this.stateContainer, object);
  }

  setDomainModel(domainModel: BaseDomainModel) {
    this.state.dataSource = domainModel;
  }

  @action clearDataSource() {
    this.state.dataSource = null;
  }

  @action setFetchingState(state) {
    runInAction(() => {
      this.state.fetchingState = state;
    });
  }

  @action setComponentState(state) {
    runInAction(() => {
      this.state.componentState = state;
    });
  }

  onChange(callback) {
    autorun(callback);
  }

  remount() {
    const dataSource = {...this.state._dataSource};
    this.clearDataSource();
    setTimeout(() => this.state.dataSource = dataSource, 0);
  }
}
